<div>
  <h3 class="mb-5 mb-lg-4 text-center text-lg-start header-mobile-style">Property Features</h3>
  <app-property-options
    label="Property Type"
    [required]="true"
    [control]="formControlType"
    [options]="(propertyTypes$ | async) || []"
    (selectOption)="typeSelected($event)" />

  <hr />

  <!-- Number steppers -->
  <app-number-of-steppers
    [requiredBedAsterisk]="requiredBedAsterisk"
    [requiredBathAsterisk]="requiredBathAsterisk"
    [formControlBedCount]="formControlBedCount"
    [formControlBathCount]="formControlBathCount"
    [formControlHalfBathCount]="formControlHalfBathCount" />

  <hr />

  <div class="property-features-inputs-container">
    <app-property-input-details [label]="sqftText" [control]="formControlSqFt" errorMessage="Square Feet is required" />
    <div class="lot-size-container">
      <app-property-input-details
        [inputType]="'text'"
        [label]="lotSizeText"
        [control]="formControlLotSizeValue"
        [pattern]="'^0-9.,'"
        (inputChange)="changeLotSizeValue($event)"
        errorMessage="Lot Size is required" />

      <app-input-radio class="lot-size-radio" [formControl]="formControlLotSizeOption" [options]="LOT_SIZE_OPTIONS" (ngModelChange)="changeLotSizeOption()" />
    </div>
    <app-property-input-details [label]="yearBuiltText" [control]="formControlYearBuilt" errorMessage="Year Built is required" />
  </div>

  <hr class="d-none d-lg-block" />

  <div class="property-options-container">
    <app-input-radio [formControl]="formControlFirePlace" label="Fireplace" [options]="FIREPLACE_OPTIONS" />

    <hr class="d-none d-lg-block" />

    <div class="property-type-dropdowns-container">
      <app-property-options label="Garage Size" [control]="formControlGarageSize" [options]="GARAGE_SIZE_OPTIONS" (selectOption)="typeSelected($event.value)" />
      <app-property-options label="Heat Type" [control]="formControlHeatType" [options]="HEAT_TYPE" (selectOption)="typeSelected($event.value)" />
    </div>

    <hr class="d-none d-lg-block" />

    <app-input-radio [formControl]="formControlBasement" label="Basement" [options]="BASEMENT_OPTIONS" />

    @if (showOccupancySection) {
      <hr class="d-none d-lg-block" />
    }
    @if (showOccupancySection) {
      <app-input-radio [formControl]="formControlOccupancy" label="Occupancy" [options]="OCCUPANCY_OPTIONS" />
    }
  </div>
</div>
